export default __webpack_public_path__ + "static/media/kitchen3-before2-2048w.7b2e3e0c.webp";